import { render } from "./Lotto6.vue?vue&type=template&id=1f1b5c67&scoped=true"
import script from "./Lotto6.vue?vue&type=script&lang=js"
export * from "./Lotto6.vue?vue&type=script&lang=js"

import "./Lotto6.vue?vue&type=style&index=0&id=1f1b5c67&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1b5c67"]])

export default __exports__